import { Outlet } from 'react-router-dom';
// 预留内部智能体的逻辑
const MobileInsideLayOut = () => {
    return <Outlet></Outlet>;
};

export default MobileInsideLayOut;
